import { render } from "./PardonUs.vue?vue&type=template&id=09035d02"
import script from "./PardonUs.vue?vue&type=script&lang=js"
export * from "./PardonUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__